import { Grid } from "@mui/material";
import { useScopeOfWork } from "../../context/ScopeOfWorkContext";
import { TypeOfPlaceCard } from "./TypeOfPlacesCard";
import { Place } from "../../context/scope-of-work.types";
import { useTypeOfPlacesQuery } from "./hooks/useTypeOfPlacesQuery";
import { QueryState } from "../../../../query-states/GlobalQueryState";

interface TypeOfPlacesProps {
  selected: Place | null;
  categoryType?: string;
}

export const TypeOfPlaces = ({ selected, categoryType }: TypeOfPlacesProps) => {
  const { dispatch } = useScopeOfWork();
  const { isLoading, isError, data: places } = useTypeOfPlacesQuery({ categoryType });
  const safePlaces = places?.items || [];

  const handleSelectPlace = (place: Place) => {
    dispatch({ type: "SET_PLACE", payload: place });
  };

  <QueryState isLoading={isLoading} isError={isError} serviceName="type of places" />;

  return (
    <Grid container spacing={2}>
      {safePlaces.map((place) => (
        <Grid item xs={12} sm={6} md={4} key={place.uid}>
          <TypeOfPlaceCard place={place} onSelect={handleSelectPlace} selected={selected?.uid === place.uid} />
        </Grid>
      ))}
    </Grid>
  );
};
